module.exports = __webpack_public_path__ + "img/ereszkalkulator_kicsi_haz_kontyolt_nyeregteto_szines.6fe2b1b7.png";